<template>
  <ProductsMob :listTitle="listTitle" :content="content"/>
</template>

<script>
export default {
  data () {
    return {
      listTitle: '机械产品设计分析软件',
      content: '<div style="font-size:16px;text-indent:2em;">dpiWorks 是一款通用的前后处理软件，功能包括三大部分：几何建模、网格剖分、结果显示。</div><br /><div style="font-size:16px;text-indent:2em;padding-top:10px;">除自身的建模功能之外，还提供多种CAD、CAE接口，包括：IGES、DXF、Parasolid、VDA、STL、Nastran等。</div><div style="font-size:16px;text-indent:2em;padding-top:10px;">网格剖分功能比较全面，一般的非结构网格可轻松生成，结构化生成网格的方法也相当丰富</div><img src="../products/5ba206764151f.png" style="width:300px;height:200px;margin:10px 20px;">'
    }
  }
}
</script>
